<template>
    <div class="content">
        <div style="height: 20px;"></div>
        <el-carousel height="370px" style="border-radius: 10px;">
            <el-carousel-item v-for="item in lunbotu" :key="item">
                <el-image style="width: 100%;height: 370px;" :src="item.tupian" :fit="fit" />
            </el-carousel-item>
        </el-carousel>

        <div class="tongzhibeijing">
            <div class="tongzhizuoce">
                <svg data-v-83f175ba="" t="1745562851000" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3605" width="20" height="20"><path data-v-83f175ba="" d="M808 712l-48-108.8V448c0-102.4-65.6-195.2-160-232-3.2-44.8-41.6-80-88-80s-83.2 35.2-88 80c-96 36.8-160 129.6-160 232v155.2l-48 108.8c-6.4 14.4-4.8 30.4 3.2 43.2 8 12.8 22.4 20.8 38.4 20.8h508.8c16 0 30.4-8 38.4-20.8s9.6-30.4 3.2-43.2z m-547.2 16l51.2-115.2V448c0-88 59.2-166.4 144-192l19.2-6.4-3.2-20.8V224c0-22.4 17.6-40 40-40s40 17.6 40 40v6.4l-3.2 20.8 19.2 6.4c84.8 25.6 144 104 144 192v164.8l51.2 115.2H260.8zM512 880c44.8 0 80-35.2 80-80H432c0 44.8 35.2 80 80 80z" fill="#e6a23c" p-id="3606"></path></svg>
                <span style="font-size: .9rem;font-weight: 600;color: #606266">最新动态</span>
            </div>
            <div>
                <div class="marquee">
                    <div class="marquee-content">
                    {{gonggao.text}}
                    </div>
                </div>
            </div>
        </div>
        <div class="shaixuancontent">
          <div class="shaixuantitle">筛选条件</div>
          <div :class="zhangkaiclass">
            <div v-for="(youceitem, index) in biaoqianinfo" :key="index" style="display: grid;grid-template-columns: 100px 1fr;padding: 0px 20px;">
              <div v-if="shuzuchangdu(youceitem.children) > 0" style="text-align: left;color: rgb(75 85 99 / var(--tw-text-opacity, 1));font-size: 14px;">{{youceitem.text}}</div>
              <div v-if="shuzuchangdu(youceitem.children) > 0" style="text-align: left;display: flex;flex-wrap: wrap;">
                <div style="padding:5px;font-size: 14px;text-align: left;" v-for="(items, key) in youceitem.children" :key="key">
                  <el-button v-if="isValueInArray(youceitem.check,items.id)" type="warning" @click="xuanzhongitem(index,items.id)">{{items.text}}</el-button>
                  <el-button v-else @click="xuanzhongitem(index,items.id)">{{items.text}}</el-button>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:15px;padding:10px 0px;font-size: 16px;text-align: center;">
            <el-button @click="zhankai">{{zhankaitext}}</el-button>
          </div>
          <div style="margin:10px;padding: 10px;background-color: #f7faffcc;border-radius: 8px;box-shadow: 0 2px 8px #0000000d;border: 1px solid rgba(79, 118, 199, .15);">
            <!-- <div style="display: grid;grid-template-columns:auto 20% 1fr;place-items: center;">
              <div style="margin-right: 10px;width: 100px;">编号:</div>
              <div style="text-align: left;margin-right: 10px;width: 100%;">
                <el-input
                v-model="datainfo.bianhao"
                style="width: 100%;height: 45px;"
                :clearable="true"
                placeholder="输入编号搜索"
                :prefix-icon="Search"
              />
              </div>
              <div></div>
            </div> -->
            <div style="margin-top:10px;display: grid;grid-template-columns:auto 1fr 1fr auto;place-items: center;">
              <div style="margin-right: 10px;width: 100px;">关键词:</div>
              <el-input
                v-model="datainfo.guanjianci"
                style="width: 100%;height: 45px;"
                :clearable="true"
                placeholder="输入编号或者关键词搜索"
                :prefix-icon="Search"
              />
              
            </div>
            
            <div style="display: grid;grid-template-columns: auto 20% auto 20% auto 1fr;place-items: center;margin-top: 10px;">
                <div style="margin-right: 10px;width: 100px;">价格区间:</div>
                <el-input v-model="datainfo.zuidijia" type="number" style="margin-left:0px;width: 100%;height: 45px;" placeholder="最低价" />
                <span style="margin: 0px 10px;">-</span>
                <el-input v-model="datainfo.zuigaojia" type="number" style="width: 100%;height: 45px;" placeholder="最高价" />
              
              
            </div>
            <div style="margin-top:10px;display: grid;grid-template-columns:auto 20% auto 1fr;place-items: center;">
              <div style="margin-right: 10px;width: 100px;">排序:</div>
              <div style="text-align: left;width: 100%;">
                <el-select
                    v-model="datainfo.paixu"
                    placeholder="请选择排序"
                    size="large"
                    style="width: 100%"
                    @change="qiehuanpaixu"
                  >
                    <el-option
                      v-for="item in paixuarray"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
              </div>
              <div style="text-align: left;margin-left: 10px;">
                <el-button style="padding: 1.3rem 1.8rem;background: rgb(240, 242, 245);color: rgb(89, 89, 89);" @click="qingkong">重置</el-button>
                <el-button type="primary" @click="shaixuan" style="border-radius: 6px;background: linear-gradient(135deg, #4f76c7, #3b5998);color: #fff;border: none;cursor: pointer;transition: all .2s;font-size: .95rem;font-weight: 500;padding: 1.3rem 1.8rem;box-shadow: 0 2px 5px #3b599833;">搜索</el-button>
              </div>
            </div>
          </div>
          
        </div>
        <el-row :gutter="20" style="margin-top: 10px;">
            <el-col :span="6" v-for="item in list" :key="item" :title="item">
                <div class="goodstab" @click="goToPage(item.id)">
                    <van-tag class="biaoqian">{{item.bianhao}}</van-tag>
                    <img src="https://oss.xuxug.com/static/images/288.jpg" alt="" class="goods_item_img" v-if="item.img == ''">
                    <img :src="item.img" alt="" class="goods_item_img" v-else-if="item.img.indexOf('https') != -1">
                    <img :src="'https://oss.xuxug.com/uploads/tupian/fzshangpin/'+item.img" alt="" class="goods_item_img" v-else>
                    <div class="goodsname">
                        <div class="card-title">{{item.title}}</div>
                    </div>
                    <div class="label-icon-box">
                        <el-button :icon="Check" style="background: linear-gradient(120deg, #f44336cc, #b71c1cb3);color: #ffebee;backdrop-filter: blur(8px);padding: 5px;">找回包赔</el-button>
                        <el-button :icon="PhoneFilled" style="background: linear-gradient(120deg, #2196f3e6, #1976d2cc);color: #fff;font-weight: 500;padding: 5px;">专属客服</el-button>
                        <el-button :icon="CircleCheckFilled" style="background: linear-gradient(120deg, #9c27b0cc, #9c27b0b3);color: #f3e5f5;padding: 5px;">平台自营</el-button>
                    </div>
                    <div style="display: grid;grid-template-columns: 1fr;">
                        <div style="text-align: left;padding: 10px 20px 5px 20px;font-size: 1.4rem;font-weight: 700;color: #e53e3e;text-shadow: 0 0 7px rgba(229, 62, 62, .2);white-space: nowrap;">¥{{item.shoujia}}</div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <div class="dibufenye">
          <el-config-provider>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="huoqufenyeshuju"
              :current-page="currentPage4"
              :page-sizes="[20]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </el-config-provider>
            
        </div>
        <div style="height: 30px;"></div>
    </div>
</template>
<script>
  import axios from 'axios'
  import { Search,Check,CircleCheckFilled,PhoneFilled } from '@element-plus/icons-vue'
  import { ElMessage } from 'element-plus'
  export default {
    name: 'ListPage', // 必须与 keep-alive 的 include 匹配
    data() {
      return {
        list: [],       // 列表数据
        loading: false, // 加载状态
        finished: false,// 是否加载完成
        showBottom: false,
        pageNum:1,
        total:0,
        pagesize:20,
        lunbotu:[],
        gonggao: "",
        activeIndex: 0,
        biaoqianinfo:[],
        activeIds: [],
        scrollTop: 0,
        shaixuanshu:0,
        activeNames:[1],
        Search:Search,
        Check:Check,
        CircleCheckFilled:CircleCheckFilled,
        PhoneFilled:PhoneFilled,
        zhankaitext:"展开",
        zhangkaiclass:"shouqitab",
        paixuarray:[{"label":"默认排序","value":0},{"label":"价格从低到高","value":1},{"label":"价格从高到低","value":2}],
        datainfo:{
          biaoqian:[],
          guanjianci:'',
          bianhao:'',
          zuidijia:'',
          zuigaojia:'',
          paixu:'',
        },
        dakaicishu:0,
      }
    },
    created() {
      document.title = 'PUBG选号网';
      this.getBaseinfo();

      console.log(this.getFromLocalStorage("guanjianci"));
      this.datainfo.guanjianci = this.getFromLocalStorage("guanjianci") != null ? this.getFromLocalStorage("guanjianci") : "";
      this.datainfo.bianhao = this.getFromLocalStorage("bianhao") != null ? this.getFromLocalStorage("bianhao") : "";
      this.datainfo.zuidijia = this.getFromLocalStorage("zuidijia") != null ? this.getFromLocalStorage("zuidijia") : "";
      this.datainfo.zuigaojia = this.getFromLocalStorage("zuigaojia") != null ? this.getFromLocalStorage("zuigaojia") : "";
      this.datainfo.paixu = this.getFromLocalStorage("paixu") != null ? this.getFromLocalStorage("paixu") : "";

      var biaoqianinfo = this.getFromLocalStorage("biaoqianinfo");
      //console.log(this.datainfo);
      if(biaoqianinfo != null)
      {
        this.biaoqianinfo = biaoqianinfo;
        this.zuzhuangshaixuancanshu();
      }
      else
      {
        this.getshaixuan();
      }

      var shaixuanshu = this.getFromLocalStorage("shaixuanshu");
      if(shaixuanshu != null)
      {
        this.shaixuanshu = shaixuanshu;
      }
      this.onLoad();
    },
    activated() {
      // 恢复滚动位置
      this.$nextTick(() => {
        const top = this.scrollTop
        document.documentElement.scrollTop = top
        document.body.scrollTop = top // iOS 兼容
      })
    },
    beforeRouteLeave(to, from, next) {
      // 记录离开时的滚动位置
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      next()
    },
    methods: {
      onLoad() {
        var that = this;
        axios.post('https://fzht.xuxug.com/api/api/newShangpinList', {
          datainfo:this.datainfo,
          page:this.pageNum,
        })
        .then(response => {
          if(response.data.code == "true")
            {
              console.log(response.data.data.total);
              console.log(that.dakaicishu);
              if(response.data.data.total <= 0 && that.dakaicishu <= 0)
              {
                console.log("001");
                ElMessage('商品已售或不存在');
                that.qingkong();
                console.log("001-1");
              }
              else
              {
                console.log("002");
                that.dakaicishu = 1;
                that.loading = false;
                that.total = response.data.data.total;
                that.list = [...that.list, ...response.data.data.data];
                that.pageNum = that.pageNum + 1;
                that.finished = that.pageNum > response.data.data.last_page;
              }
            }
            else
            {
              that.loading = false;
              that.finished = true;
            }
        })
        .catch(error => {
          console.log(error);
          that.loading = false;
          that.finished = true;
        });
      },
      async getshaixuan() {
        axios.get('https://fzht.xuxug.com/api/api/getAllTags')
        .then(response => {
          if(response.data.code == "true")
          {
            this.biaoqianinfo = response.data.data;
          }
        })
        .catch(error => {
          // 处理错误情况
          console.error("There was an error!", error);
        });
        
      },
      async getBaseinfo() {
        axios.get('https://fzht.xuxug.com/api/api/getBaseInfo')
        .then(response => {
          if(response.data.code == "true")
          {
            this.lunbotu = response.data.data.lunbotu;
            this.gonggao = response.data.data.gonggao;
          }
        })
        .catch(error => {
          // 处理错误情况
          console.error("There was an error!", error);
        });
        
      },
      zhankai(){
        if(this.zhankaitext == "展开")
        {
          this.zhankaitext = "收起";
          this.zhangkaiclass = "zhangkaitab";
        }
        else
        {
          this.zhankaitext = "展开";
          this.zhangkaiclass = "shouqitab";
        }
      },
      huoqufenyeshuju(val){
        console.log(val);
        this.pageNum = val;
        this.list = [];
        this.onLoad();
      },
      handleSizeChange(){

      },
      saveToLocalStorage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
      },
      getFromLocalStorage(key) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      },
      removeLocalStorageItem(key) {
        localStorage.removeItem(key);
      },
      showShaixuan(){
        this.showBottom = true;
      },
      huoquleixing(){
        console.log("2222");
      },
      shuaXin(){
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      },
      qingkong(){
        this.datainfo.biaoqian = [];
        this.datainfo.guanjianci = '';
        this.datainfo.bianhao = '';
        this.datainfo.zuidijia = '';
        this.datainfo.zuigaojia = '';
        this.datainfo.paixu = 0;
        this.shaixuanshu = 0;
        this.biaoqianinfo.forEach(function (element) {
          element.check = [];
          element.badge = "";
        });
        this.removeLocalStorageItem("biaoqianinfo");
        this.getshaixuan();
        this.shaixuan();
      },
      zuzhuangshaixuancanshu(){
        var that = this;
        that.datainfo.biaoqian = [];
        this.biaoqianinfo.forEach(function (element) {
          that.datainfo.biaoqian = [...that.datainfo.biaoqian, ...element.check];
        });
        that.shaixuanshu = that.datainfo.biaoqian.length;
        this.saveToLocalStorage("biaoqianinfo",this.biaoqianinfo);
        this.saveToLocalStorage("shaixuanshu",this.shaixuanshu);
        this.saveToLocalStorage("guanjianci",this.datainfo.guanjianci);
        this.saveToLocalStorage("bianhao",this.datainfo.bianhao);
        this.saveToLocalStorage("zuidijia",this.datainfo.zuidijia);
        this.saveToLocalStorage("zuigaojia",this.datainfo.zuigaojia);
        this.saveToLocalStorage("paixu",this.datainfo.paixu);
      },
      qiehuanpaixu(){
        this.shaixuan();
      },
      shaixuan(){
        this.zuzhuangshaixuancanshu();
        //this.datainfo.paixu = this.paixuvalue;
        this.pageNum = 1;
        this.list = [];
        this.showBottom = false;
        this.onLoad();
      },
      onSearch(){
        this.zuzhuangshaixuancanshu();
        this.pageNum = 1;
        this.list = [];
        this.onLoad();
      },
      onCancel(){
        this.datainfo.guanjianci = '';
      },
      shuzuchangdu(shuzu){
        return shuzu.length;
      },
      isValueInArray(shuzu,value){
        return shuzu.includes(value);
      },
      xuanzhongitem(index,value){
        if(this.isValueInArray(this.biaoqianinfo[index].check,value))
        {
          if(this.biaoqianinfo[index].type == "1")
          {
            this.biaoqianinfo[index].check = [];
          }
          else
          {
            console.log("shanchu");
            this.biaoqianinfo[index].check = this.biaoqianinfo[index].check.filter(item => item !== value);
          }
          
        }
        else
        {
          if(this.biaoqianinfo[index].type == "1")
          {
            this.biaoqianinfo[index].check = [];
            this.biaoqianinfo[index].check.push(value);
          }
          else
          {
            this.biaoqianinfo[index].check.push(value);
          }
        }

        var changdu = this.biaoqianinfo[index].check.length;
        if(changdu > 0)
        {
          this.biaoqianinfo[index].badge = changdu;
        }
        else
        {
          this.biaoqianinfo[index].badge = "";
        }
        this.shaixuan();
      },
      goToPage(id){
        //this.$router.push({ path: '/detail', query: { id: id } })
        //location.href = '/detail?id='+id; 
        
        window.open('detail?id='+id); 
      },
      daysAgo(shijian) {
        const dateString = shijian.split(' ')[0];
        const date = new Date(dateString); // 将字符串转换为Date对象
        const now = new Date(); // 获取当前日期和时间
        const diffTime = now - date; // 计算两个日期之间的差异（毫秒）
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 转换为天数并向上取整以处理非整天数的情况
        return diffDays === 0 ? '今天' : `${diffDays}天前`; // 如果是一天以内，显示“今天”，否则显示天数加“天前”
      },
    }
  }
  </script>
  <style scoped>
    .content{
        margin: 0 auto;
        max-width: 1350px;
    }
    .tongzhibeijing{
      margin: 10px 0px;
      padding: 10px;
      display: grid;
      grid-template-columns: auto 1fr;
      border-radius: 5px;
      background: #ffffff;
    }
    .tongzhizuoce{
      display: flex;justify-content: left;align-items: center;margin-left:5px;border-right: 1px solid #E1E8F6;
      padding-right: 30px;
    }
    .marquee {
        overflow: hidden;
        position: relative;
        margin-left: 1%;
        width: 98%; /* 或者具体的宽度 */
        height: 20px; /* 或者具体的高度 */
        white-space: nowrap; /* 防止内容换行 */
        box-sizing: border-box; /* 包括内边距和边框在内的总宽度和高度 */
        }
        
        .marquee-content {
            position: absolute;
            white-space: nowrap;
            animation: marqueeAnimation 20s linear infinite; /* 动画名称、持续时间、速度曲线、重复次数 */
            color: #606266;
            font-size: .9rem;
            }
        
        @keyframes marqueeAnimation {
        0% { transform: translateX(100%); }
        100% { transform: translateX(-100%); }
        }
        .el-row {
            margin-bottom: 20px;
            }
            .el-row:last-child {
            margin-bottom: 0;
            }
            .el-col {
            border-radius: 4px;
            }

            .grid-content {
            border-radius: 4px;
            min-height: 36px;
            }
    .goodsname{
      padding: 5px 10px;
    }
    .goods_item_img {
      width: 100%;
      height: 190px;
      border-radius: 5px 0 0 0px;
      display: block;
      object-fit: cover;
    }
    .card-title {
        text-align: left;
        margin: 10px 0px;
        font-size: 1rem;
        font-weight: 700;
        margin: 0 0 .75rem;
        line-height: 1.4;
        height: 2.8rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: color .3s ease;
        color: #2a4365;
    }
    .biaoqian{
        position: absolute;
        top: .5rem;
        right: .5rem;
        padding: .25rem .625rem;
        background: #38b2accc;
        color: #fff;
        font-size: .9rem;
        font-weight: 600;
        border-radius: .25rem;
        z-index: 2;
        box-shadow: 0 0 10px #38b2ac80;
        transition: all .3s ease;
    }
    .dibufenye
    {
        margin: 0 auto;
        padding: 20px 20px;
        width: 800px;
        background: #ffffff;
        border-radius: 10px;
    }
    .shaixuancontent{
      padding-bottom: 10px;
      border-radius: 10px;
      background: #ffffff;
    }
    .shaixuantitle{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem 1.5rem;
      border-bottom: 1px solid rgba(0, 0, 0, .05);
      background: #f8f5f0cc;
    }
    .zhangkaitab{
      margin-top: 10px;
      overflow: hidden;
      transition: opacity 0.5s;
    }
    .shouqitab{
      margin-top: 10px;max-height: 300px;overflow: hidden;transition: height 0.3s ease;transition: opacity 0.5s;
    }
    .goodstab{
      position:relative;
      background: #fffffff2;
      margin-bottom:20px;
      border-radius: .5rem;
      overflow: hidden;
      padding: 0px 0px 10px 0px;
      transition: all .4s cubic-bezier(.175,.885,.32,1.275);
      border: 1px solid rgba(79, 118, 199, .2);
      box-shadow: 0 4px 10px #0000000d;
    }
    .goodstab:hover {
      transform: translateY(-10px);
    }
    .goodstab:hover .card-title {
      color: #6F90D1; /* 当你将鼠标悬停在父div上时，子div的文字会变成红色 */
    }
  </style>